// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MetaInfo from 'vue-meta-info'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import '@/assets/css/bootstrap.min.css'
import '@/assets/css/global.css'
import '@/assets/js/jquery.min.js'
import '@/assets/js/bootstrap.min.js'
import VueI18n from 'vue-i18n'
import  LangEn from '../static/lang/en'
import  LangZh from '../static/lang/zh'
import axios from 'axios'
//import VueWechatTitle from 'vue-wechat-title'

//Vue.use(VueWechatTitle)

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper, /* { default global options } */)

Vue.use(VueI18n)
Vue.prototype.$http= axios

Vue.use(MetaInfo)





const i18n = new VueI18n({
  locale: sessionStorage.getItem('locale') || 'cn', 
  messages:{
    'en': LangEn,
    'cn': LangZh,
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js